import { NextPage } from 'next'
import { useTranslation } from 'next-i18next'

import { DEFAULT_LAYOUT_TRANSLATION_MODULE_NAMES } from '~/shared/layouts/constants'
import { DefaultLayout } from '~/shared/layouts/DefaultLayout'
import { usePageTitle } from '~/utils/tags'
import Metatags from '~/components/Metadata/Metatags'
import AuthGuard from '~/components/AuthGuard'
import useCurrentUser from '~/hooks/useCurrentUser'
import { getStaticPropsWrapper } from '~/utils/pageWrapper/staticPageWrapper'
import { GetProps } from '~/utils/pageWrapper/types'
import StatisticsV2 from '~/statistics-v2/pages/StatisticsV2.page'

const StatisticsPage: NextPage = () => {
  const { t } = useTranslation('statistics')

  const user = useCurrentUser()
  const title = t('pageTitle', { username: user?.nickname ? `| ${user.nickname}` : '' })
  const pageTitle = usePageTitle(title)

  return (
    <div>
      <Metatags metaDescription={t('metaDescription')} noindex title={pageTitle} />

      <AuthGuard showSplash>
        <DefaultLayout zeroPadding>
          <StatisticsV2 />
        </DefaultLayout>
      </AuthGuard>
    </div>
  )
}

const getProps: GetProps = () => () => ({
  props: {
    namespaces: [
      'errors',
      'fields',
      'validation',
      'settings',
      'avatar',
      'statistics',
      'leaderboard',
      'homebase',
      'statisticsV2',
      ...DEFAULT_LAYOUT_TRANSLATION_MODULE_NAMES,
    ],
  },
})

export const getStaticProps = getStaticPropsWrapper(getProps)

export default StatisticsPage
